import AwardTop from './../../../../commons/components/Award/AwardTop'
import BtnGoToAwardRegister from './BtnGoToAwardRegister';

type props = {};

const RealTimeRankingComponent = ({entries = [], entry = {}, award = {}}: props) => {

  return (
    <div className="awards-top-ten">
      <div className="awards-top-ten__intro">
        <label className="awards-top-ten__intro__description">
          매일 오전 10시에 순위를 확인해보세요!
        </label>
        <label className="awards-top-ten__intro__title">
          실시간 순위확인하기
        </label>
        <label className="awards-top-ten__intro__time">
          스포키즈 {award.year} {award.season} AWARDS!
        </label>
      </div>
      <AwardTop
        entries={entries}
      />
      {!entry.id && <div className="main-awards-register-btn text-center">
        <BtnGoToAwardRegister show={!entry.id} />
      </div>}
    </div>
  );
};

export default RealTimeRankingComponent;
